import React, { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { FloatingLabelInput, UIText } from "src/components/uIKit";
import { ErrorMessage, Iframe } from "src/components";
import Separator from "src/components/separator";
import styles from "./styles.module.scss";
import { useAppDispatch, useAppSelector } from "src/hooks/useRedux";
import { API_RESULT, STATE } from "src/utils/enums";
import {
  getIframeUrl,
  inquireGCIframeResults,
} from "src/redux/slices/appSlice/AppApi";
import { getCCInfo } from "src/redux/slices/userSlice/UserApi";
import { setInquiryGCIframeResultsResStatus } from "src/redux/slices/appSlice/AppSlice";
import { FULL_URL } from "src/utils/consts";
import { uiCustomData } from "src/utils/consts";
import { __DEV__, getChannelId } from "src/utils/utils";

interface CardInfoProps {
  strings: any;
  validationRules: any;
  iframeUrl: string;
  showTitle: boolean;
}

const CardInfo: React.FC<CardInfoProps> = ({
  strings,
  validationRules,
  iframeUrl = "",
  showTitle = true,
}) => {
  const { control } = useFormContext();
  const dispatch = useAppDispatch();
  const [isError, setIsError] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [refreshIframe, setRefreshIframe] = useState(false);
  const {
    inquiryGCIframeResultsResStatus,
    businessUnit,
    personalId,
    txId,
    travelPolicyNumber,
    inquiryGCIframeResultsRes,
    inquiryGCIframeResultsError,
    currentState,
    hostUrl,
  } = useAppSelector((state) => state.app);
  const { personalDetailsRes, creditCards } = useAppSelector(
    (state) => state.user
  );
  const responseCodes = {
    1: strings.t_iframe_response_1,
    2: strings.t_iframe_response_2,
    3: strings.t_iframe_response_3,
    4: strings.t_iframe_response_4,
    5: strings.t_iframe_response_5,
    6: strings.t_iframe_response_6,
    7: strings.t_iframe_response_7,
    8: strings.t_inquire_cg_iframe_result_error_no_cards,
  };
  useEffect(() => {
    if (currentState === STATE.UPDATE_CONTACT_DETAILS) {
      setErrorText("");
    }
  }, [currentState]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const { status } = event.data;
      if (status === API_RESULT.SUCCEEDED) {


        const currentTxId = txId;

        setIsError(false);
        __DEV__ && console.log("currentTxId", currentTxId);
        getIframeResults(currentTxId);
      } else if (status === API_RESULT.FAILED) {
        setTimeout(() => {
          setRefreshIframe(true);
          getIfraimAgain();
        }, 1000);

        // check if user have cards
        __DEV__ && console.log("inquiryGCIframeResultsError", inquiryGCIframeResultsError);
        // const responseCode = inquiryGCIframeResultsError?.data?.responseCode;
        // if (responseCode>0) {
        //   const resText = responseCodes[responseCode as keyof typeof responseCodes];
        //   setErrorText(resText);
        //   console.log("resText", resText);


        // }

        if (creditCards.length === 0) {
          setErrorText(strings.t_inquire_cg_iframe_result_error_no_cards);
        } else {
          setErrorText(strings.t_inquire_cg_iframe_result_error);
        }


        // console.log("!!22222 inquiryGCIframeResultsError", inquiryGCIframeResultsError);
        // if (inquiryGCIframeResultsError){
        //   handlingErrorCodes(inquiryGCIframeResultsError?.data?.responseCode);
        // }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [txId]);

  useEffect(() => {
    if (inquiryGCIframeResultsResStatus === API_RESULT.SUCCEEDED) {
      if (inquiryGCIframeResultsRes.responseCode == 0) {
        const data = {
          feCustTravelPolicyNumber: travelPolicyNumber,
          feCustPersonalId: personalId,
          feBU: businessUnit,
        };

        dispatch(getCCInfo(data));
        dispatch(setInquiryGCIframeResultsResStatus(API_RESULT.IDLE));
      } else {
        handlingErrorCodes(inquiryGCIframeResultsRes);
      }
    } else if (inquiryGCIframeResultsResStatus === API_RESULT.FAILED) {

      setTimeout(() => {
        setIsError(true);
        __DEV__ && console.log("!!!!! inquiryGCIframeResultsError", inquiryGCIframeResultsError);
        handlingErrorCodes(inquiryGCIframeResultsError.data.responseCode);
      }, 2000);
    }
  }, [inquiryGCIframeResultsResStatus]);

  const handlingErrorCodes = (responseCode: any) => {
    if (responseCode > 0) {
      const resText = responseCodes[responseCode as keyof typeof responseCodes];
      setErrorText(resText);
      // setTimeout(() => {
      setRefreshIframe(true);
      // getIfraimAgain();
      // }, 1000);
    }
    dispatch(setInquiryGCIframeResultsResStatus(API_RESULT.IDLE));
  };

  const getIfraimAgain = () => {
    const currentPath = window.location.pathname; // This will get the path part after the domain
    const data = {
      personalId,
      jsonConfig: uiCustomData,
      failureRedirectUrl: `${FULL_URL}${currentPath}/failure`,
      successRedirectUrl: `${FULL_URL}${currentPath}/success`,
      businessUnit
    };
    dispatch(getIframeUrl(data));
  };

  const getIframeResults = (currentTxId = txId) => {
    if (!currentTxId) {
      return;
    }

    const data = {
      businessUnit,
      personalId,
      txId: currentTxId,
      travelPolicyNumber,
      feChannel: getChannelId(hostUrl),
    };

    dispatch(inquireGCIframeResults(data));
  };
  return (
    <>
      {showTitle && (
        <>
          <Separator className={styles.noMargin} />
          <UIText
            text={strings.t_active_credit_add_other_payment}
            size={18}
            weight={500}
            style={styles.sectionTitle}
          />
        </>
      )}

      <div className={styles.cardinfoWrapper}>
        <div>
          <UIText
            text={strings.t_card_holder_details}
            size={16}
            weight={400}
            style={styles.sectionTitle}
          />
          <Controller
            name="firstNameCard"
            control={control}
            rules={validationRules.firstName}
            render={({ field, fieldState: { error } }) => (
              <>
                <FloatingLabelInput
                  label={strings.t_card_details_first_name}
                  {...field}
                  style={styles.mBottom0}
                  disabled={true}
                  defaultInputValue={personalDetailsRes?.feCustFirstNameEng + " " + personalDetailsRes?.feCustLastNameEng}
                />
                <ErrorMessage
                  style={styles.mailError}
                  message={error?.message}
                />
              </>
            )}
          />
          <Controller
            name="idCard"
            control={control}
            rules={validationRules.id}
            render={({ field, fieldState: { error } }) => (
              <>
                <FloatingLabelInput
                  label={strings.t_card_details_id}
                  {...field}
                  disabled={true}
                  style={styles.mBottom0}
                  defaultInputValue={personalId}
                />
                <ErrorMessage
                  style={styles.mailError}
                  message={error?.message}
                />
              </>
            )}
          />
          <Separator className={styles.noMargin} />
        </div>
        {iframeUrl && (
          <UIText
            text={strings.t_card_details}
            size={16}
            weight={400}
            style={styles.sectionTitle}
          />
        )}

        <Iframe src={iframeUrl} refresh={refreshIframe} />
        {Boolean(errorText?.trim()) && (
          <div className={styles.errorWrapper}>
            <Separator />
            <ErrorMessage message={errorText} />
            {/* <Separator /> */}
          </div>
        )}
      </div>
    </>
  );
};

export default CardInfo;
